<template>
  <svg
    width="128"
    height="128"
    viewBox="0 0 128 128"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M127.285 110.369C123.562 108.152 122.111 104.868 121.661 101.718C122.538 99.2653 123.044 96.6329 123.044 93.8767V80.1748C123.044 67.3278 112.627 56.8994 99.7689 56.8994H49.2021C36.3551 56.8994 25.9268 67.3165 25.9268 80.1748V93.8767C25.9268 106.724 36.3439 117.152 49.2021 117.152H99.7689C105.18 117.152 110.141 115.285 114.101 112.191C118.218 113.8 122.617 113.923 126.925 112.979C128.174 112.697 128.388 111.032 127.285 110.38V110.369Z"
      fill="#CB80DE"
    />
    <path
      d="M72.1286 10H25.6342C14.0583 10 4.67621 19.3821 4.67621 30.9692C4.67621 33.5678 5.17119 36.0427 6.03741 38.3377C5.12619 40.6101 3.48375 42.7587 0.615115 44.2999C-0.341098 44.8174 -0.138606 46.2349 0.918853 46.4936C4.54121 47.3823 8.25357 47.5286 11.8084 46.6961C15.4983 49.9472 20.3356 51.9384 25.6454 51.9384H72.1286C83.7044 51.9384 93.0978 42.5562 93.0978 30.9692C93.0978 19.3934 83.7157 10 72.1286 10Z"
    />
    <path
      d="M51.7894 94.1242C55.716 94.1242 58.8991 90.9411 58.8991 87.0145C58.8991 83.0879 55.716 79.9048 51.7894 79.9048C47.8628 79.9048 44.6797 83.0879 44.6797 87.0145C44.6797 90.9411 47.8628 94.1242 51.7894 94.1242Z"
    />
    <path
      d="M74.4911 94.1242C78.4177 94.1242 81.6008 90.9411 81.6008 87.0145C81.6008 83.0879 78.4177 79.9048 74.4911 79.9048C70.5645 79.9048 67.3813 83.0879 67.3813 87.0145C67.3813 90.9411 70.5645 94.1242 74.4911 94.1242Z"
    />
    <path
      d="M97.1927 94.1242C101.119 94.1242 104.302 90.9411 104.302 87.0145C104.302 83.0879 101.119 79.9048 97.1927 79.9048C93.2661 79.9048 90.083 83.0879 90.083 87.0145C90.083 90.9411 93.2661 94.1242 97.1927 94.1242Z"
    />
  </svg>
</template>

<script>
  export default {
    name: 'FaqCustomerSupport'
  }
</script>
